/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appList: [],
  v2AppList: [],
  oneInsightPerm: [],
};

const config = createSlice({
  name: "main",
  initialState: { ...initialState },
  reducers: {
    setAppList: (state, action) => {
      state.appList = action.payload;
    },
    setV2AppList: (state, action) => {
      state.v2AppList = action.payload;
    },
    setOneInsightPerm: (state, action) => {
      state.oneInsightPerm = action.payload;
    },
  },
});
const { reducer, actions } = config;

export const getMainState = (state) => state.main;

export const { setAppList, setV2AppList, setOneInsightPerm } = actions;
export default reducer;
